import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { getUserEmail, getUserToken } from "../libs/user";
import { addRakutenCard, getaddedbank, getCardToken } from "../services/plaid";
import successIcon from "../assets/img/done_icon.svg";
import failedIcon from "../assets/img/denied.svg";
import infoIcon from "../assets/img/error_icon.svg";
import appConfig from "../config/app.config";
import {
  Conversion,
  getUtmCampaign,
  getUtmMedium,
  getUtmSource,
  HQUserBankAdd,
  Web_Bank_link_completed,
  Web_Bank_link_completed_frontend,
  Web_card_popup_fired,
} from "../libs/events";
import { setMessagePopup } from "../redux/slices/authSlice";
import CustomPopup from "../pages/CustomPopup";

function AddCard({
  open,
  addCard,
  redirectPath,
  refreshAccount,
  messagePopup = false,
  source,
}) {
  const navigation = useNavigate();
  const cardRef = useRef();
  const popupMessageRef = useRef();
  const popupLoadingRef = useRef();
  const frameRef = useRef();
  const authToken = getUserToken();
  const loaderRef = useRef();
  const popupCardResponseRef = useRef();
  const [cardAddResponse, setCardAddResponse] = useState({});

  const [showPopup, setshowPopup] = useState(messagePopup);
  const timeout0 = useRef();

  const fingerprint = useSelector((state) => state.fingerprint);

  const [rcToken, setRcToken] = useState(null);
  const dispatch = useDispatch();

  const bankLinked = (data) => {
    Conversion({
      value: 1.0,
      currency: "USD",
      transaction_id: "",
    });

    getaddedbank(authToken)
      .then((response) => {
        Web_Bank_link_completed({
          web_bank_linked: true,
          no_of_active_banks: response.active_account_count,
          utm_source: getUtmSource(),
          utm_medium: getUtmMedium(),
          utm_campaign: getUtmCampaign(),
          type: "clo",
          email: getUserEmail(),
        });
        if (response.user_category === "$3") {
          HQUserBankAdd({
            transaction_id: "",
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const messageHandler = (response) => {
    if (response.data.status === 200) {
      rakutenAddCard(response.data.cardId);
    } else {
      if (response.data.message == "Invalid token.") {
        cardRef.current.innerHTML = "Session expired please try again.";
        popupMessageRef.current.style.visibility = "visible";
      }
    }
  };

  const rakutenAddCard = (cardToken) => {
    addRakutenCard(cardToken, authToken, fingerprint.data)
      .then((response) => {
        bankLinked(response);
        popupCardResponseRef.current.style.visibility = "visible";

        if (response.success === true) {
          Web_Bank_link_completed_frontend({
            utm_source: getUtmSource(),
          });
          if (redirectPath) {
            window.tcWebBridge.saveUserState({ status: "accept" });
          } else {
            window.tcWebBridge.sendUserState({ status: "accept" });
          }
        } else {
          if (redirectPath) {
            window.tcWebBridge.saveUserState({ status: "reject" });
          } else {
            window.tcWebBridge.sendUserState({ status: "reject" });
          }
        }

        setCardAddResponse(response);
        if (response.success === true) {
          timeout0.current = setTimeout(() => {
            if (redirectPath) {
              navigation(redirectPath);
            } else {
              if (refreshAccount) {
                refreshAccount(authToken);
              }
              if (source !== "toiPlus") {
                open(false);
              }
            }
          }, 2000);
        }
      })
      .catch((error) => {
        window.tcWebBridge.sendUserState({ status: "reject" });
        console.log(error);
      });
  };

  const cardToken = (authToken) => {
    popupLoadingRef.current.style.visibility = "visible";
    getCardToken(authToken)
      .then((response) => {
        loaderRef.current = setTimeout(() => {
          popupLoadingRef.current.style.visibility = "hidden";
        }, 1500);

        setRcToken(response.linkToken);
      })
      .catch((error) => {
        setRcToken(null);
        console.log(error);
      });
  };

  useEffect(() => {
    if (addCard === true) {
      cardToken(authToken);
      document.body.style.overflow = "hidden";
    }

    return () => {
      clearTimeout(loaderRef.current);
      clearTimeout(timeout0.current);
      document.body.style.overflow = "auto";
    };
  }, [addCard]);

  useEffect(() => {
    window.addEventListener("message", messageHandler);

    return () => {
      window.removeEventListener("message", messageHandler);
    };
  }, []);

  const handleClose = () => {
    setshowPopup(false);
  };

  useEffect(() => {
    if (messagePopup) {
      Web_card_popup_fired();
    }
  }, []);

  return (
    <div className="popup-container">
      <div className="popup-body">
        <div className="popup-header">
          <svg
            height="28"
            width="28"
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path d="M4 4a2 2 0 00-2 2v1h16V6a2 2 0 00-2-2H4z" />
            <path
              fillRule="evenodd"
              d="M18 9H2v5a2 2 0 002 2h12a2 2 0 002-2V9zM4 13a1 1 0 011-1h1a1 1 0 110 2H5a1 1 0 01-1-1zm5-1a1 1 0 100 2h1a1 1 0 100-2H9z"
              clipRule="evenodd"
            />
          </svg>{" "}
          <span style={{ paddingLeft: "8px", fontWeight: "300" }}>
            Add an eligible card
          </span>
        </div>
        <div className="popup-close" onClick={() => open(false)}>
          <svg
            width="32"
            height="32"
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={1}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </div>
        <div style={{ clear: "both" }}></div>
        <div ref={popupLoadingRef} className="popup-message-box">
          <div className="popup-message-text">
            <div className="loaderBox" style={{ margin: "0 0 16px" }}>
              <div className="circle-loader-wrap">
                <div className="left-wrap">
                  <div className="loader"></div>
                </div>
                <div className="right-wrap">
                  <div className="loader"></div>
                </div>
              </div>
            </div>
            <div>Initializing Session</div>
          </div>
        </div>
        <div ref={popupCardResponseRef} className="popup-message-box">
          <div className="popup-message-text">
            {cardAddResponse.success === true && <img src={successIcon} />}
            {cardAddResponse.success === false && (
              <img style={{ width: "78px", height: "78px" }} src={failedIcon} />
            )}
            <div style={{ marginTop: "16px" }}>{cardAddResponse.message}</div>
          </div>
        </div>
        <div ref={popupMessageRef} className="popup-message-box">
          <div className="popup-message-text">
            <img src={infoIcon} />
            <div style={{ marginTop: "16px" }} ref={cardRef}></div>
            {/* <button
              onClick={() => retryAddCard()}
              className="btn"
              style={{
                borderRadius: "8px",
                marginTop: "16px",
                cursor: "pointer",
              }}
            >
              Retry
            </button> */}
          </div>
        </div>
        {rcToken !== null && (
          <iframe
            ref={frameRef}
            className="popup-rakuten-frame"
            src={`${appConfig.rakutenUrl}?token=${rcToken}`}
          ></iframe>
        )}
      </div>
      {showPopup && (
        <CustomPopup
          heading="Input Card Number"
          descrText1="Please enter your card number to get free TOI+"
          descrText3="subscription and a $5 welcome bonus on Abound app instantly. You will not be asked to enter CVV or expiry date of your card."
          descrText2="This is completely secure and you’ll never be charged."
          handleAction={handleClose}
        />
      )}
    </div>
  );
}

AddCard.defaultProps = {
  refreshAccount: null,
};

export default AddCard;
